module.exports = __webpack_public_path__ + "static/image/company/pc/image_report@3x.ver2_0_2.jpg?37cac228";